import React from "react"
import { wordTitleCase } from "helpers/data-formatters"

const TitleText = cell => {
  return wordTitleCase(cell.value)
}

export { TitleText }
